export default "__VITE_ASSET__kLCq8UiU__"